import EmbeddedFormPage from './EmbeddedFormPage';

const WonderschoolPhoneNumberPage = () => (
  <EmbeddedFormPage
    titleKey="Wonderschool Phone Number"
    description="Fill out this form to get started with your Wonderschool Phone Number. The Wonderschool Phone Number is a dedicated business line that helps you keep parent communication separate from your personal calls and texts."
    formUrl="https://wonderschool.fillout.com/t/bM8H31Cbkhus"
  />
);

export default WonderschoolPhoneNumberPage;
